<app-site-widget
	title="Site Battery Aging"
	elementId="batt_ramaining_warranty"
	widgetClass="height-600"
  	[widgetOptions]="{noExpand: true,hasExport: true}"
	[data]="data"
	[hideTable]="true"
	[hideDevs]="true"
	[titleStyle]="true"
	(eventEmit)="eventEmit($event)"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>
